import { render, staticRenderFns } from "./OrderDetailWidget.vue?vue&type=template&id=a9b2ed7c&scoped=true&"
import script from "./OrderDetailWidget.vue?vue&type=script&lang=js&"
export * from "./OrderDetailWidget.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailWidget.vue?vue&type=style&index=0&id=a9b2ed7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b2ed7c",
  null
  
)

export default component.exports